import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { 
  getToken, 
} from "./Utils/Common";

import './App.css';
import './CssFiles/CommonStyle.css';
import './CssFiles/CustomStyle.css';
import './CssFiles/Responsiveness.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from "./Page/Login/Login";
import Member from "./Page/Member/Member";
import AddEditMember from "./Page/Member/AddEditMember";
import MemberProfile from "./Page/Member/MemberProfile";
import ChangeStatus from "./Page/ChangeStatus/ChangeStatus";
import Corporate from "./Page/Corporate/Corporate";
import CorporateProfile from "./Page/Corporate/CorporateProfile";
import MemberReport from "./Page/Reports/MemberReport";
import CorporateReport from "./Page/Reports/CorporateReport";
// import RecurringTransaction from "./Page/RecurringTransaction/RecurringTransaction";
import Credit from "./Page/Credit/Credit";
import RefundableDeposit from "./Page/Credit/CreditLimit";
import Users from "./Page/Users/Users";
import Dashboard from "./Page/Dashboard/Dashboard";

import { Toaster } from 'react-hot-toast';
import RecurringTransaction from "./Page/Credit/RecurringTransaction";
import Billing from "./Page/Credit/Billing";
import GenerateBillings from "./Page/Credit/GenerateBillings";
import ViewMemberBilling from "./Page/Credit/ViewMemberBilling";
import Payment from "./Page/Credit/Payment";
import AddPayment from "./Page/Credit/AddPayment";
import PreviewPayment from "./Page/Credit/PreviewPayment";
import TransactionHistory from "./Page/TransactionHistory/TransactionHistory";

function AccountingRedirect({ to }) {
  const location = useLocation();
  const { id } = useParams();
  const pathname = id ? `${to}/${encodeURIComponent(id)}` : to;
  return <Navigate to={{ pathname, search: location.search, hash: location.hash }} state={location.state} replace />;
}

function App() {
  const userToken = getToken();

  const toastOptions = {
    duration: 3000,
    style: {
      fontFamily: 'var(--font-regular)',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgba(0, 0, 0, 0.9)', 
      color: '#fff', 
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out', 
    },
    success: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(65, 184, 131, 0.9)', 
      },
    },
    error: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(255, 99, 71, 0.9)', 
      },
    },
  };

  return (
    <div className="page">
      <Toaster position="top-right" toastOptions={toastOptions} />
      <Router>
        <Routes>
          <Route path="/" element={userToken ? <Dashboard/> : <Login/>}/>
          <Route path="/dashboard" element={userToken ? <Dashboard/> : <Login/>}/>
          <Route path="/member" element={userToken ? <Member/> : <Login/>}/>
          <Route path="/user" element={userToken ? <Users/> : <Login/>}/>
          <Route path="/member/:type/:id?" element={userToken ? <AddEditMember/> : <Login/>}/>
          <Route path="/member/profile" element={userToken ? <MemberProfile/> : <Login/>}/>
          <Route path="/status" element={userToken ? <ChangeStatus/> : <Login/>}/>
          <Route path="/corporate" element={userToken ? <Corporate/> : <Login/>}/>
          <Route path="/accounting/recurring-transaction" element={userToken ? <RecurringTransaction/> : <Login/>}/>
          <Route path="/accounting/generate-billings" element={userToken ? <GenerateBillings/> : <Login/>}/>
          <Route path="/accounting/billing" element={userToken ? <Billing/> : <Login/>}/>
          <Route path="/credit/refundable-deposit" element={userToken ? <RefundableDeposit/> : <Login/>}/>
          <Route path="/credit/limit" element={<Navigate to="/credit/refundable-deposit" replace/>}/>
          <Route path="/accounting/view-billing/:id" element={userToken ? <ViewMemberBilling/> : <Login/>}/>
          <Route path="/accounting/payment" element={userToken ? <Payment/> : <Login/>}/>
          <Route path="/accounting/add-payment" element={userToken ? <AddPayment/> : <Login/>}/>
          <Route path="/accounting/view-payment/:id" element={userToken ? <PreviewPayment/> : <Login/>}/>
          <Route path="/corporate/profile/:id" element={userToken ? <CorporateProfile/> : <Login/>}/>
          <Route path="/credit" element={userToken ? <Credit/> : <Login/>}/>
          <Route path="/report/member" element={userToken ? <MemberReport/> : <Login/>}/>
          <Route path="/report/corporate" element={userToken ? <CorporateReport/> : <Login/>}/>
          <Route path="/accounting/transaction-history" element={userToken ? <TransactionHistory/> : <Login/>}/>
          <Route path="/credit/recurring-transaction" element={<AccountingRedirect to="/accounting/recurring-transaction"/>}/>
          <Route path="/credit/generate-billings" element={<AccountingRedirect to="/accounting/generate-billings"/>}/>
          <Route path="/credit/billing" element={<AccountingRedirect to="/accounting/billing"/>}/>
          <Route path="/credit/view-billing/:id" element={<AccountingRedirect to="/accounting/view-billing"/>}/>
          <Route path="/credit/payment" element={<AccountingRedirect to="/accounting/payment"/>}/>
          <Route path="/credit/add-payment" element={<AccountingRedirect to="/accounting/add-payment"/>}/>
          <Route path="/credit/view-payment/:id" element={<AccountingRedirect to="/accounting/view-payment"/>}/>
          <Route path="/transaction-history" element={<AccountingRedirect to="/accounting/transaction-history"/>}/>
          <Route path="/recurring-transaction" element={<AccountingRedirect to="/accounting/recurring-transaction"/>}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
